import Head from "next/head";
import { useEffect, useState } from "react";
import NoIndexMeta from "@/components/Common/NoIndexMeta";
import { DEFAULT_IMAGE } from "@/constastants/Constant";
import { getCleanUrl } from "@/utils/Common";

const DEFAULT_META_IMAGE = DEFAULT_IMAGE;
const DEFAULT_META_TITLE = "Elchemy";
const DEFAULT_META_DESCRIPTION = "Elchemy";

const MetaTags = (props) => {
  const [canonical, setCanonical] = useState("");

  const {
    title,
    description,
    image,
    NoIndexMetaKey = true,
    addKey = null,
    defaultCanonical,
    metaTitle = null,
    includeAlternateLink = false,
  } = props;

  useEffect(() => {
    if (window) {
      setCanonical(defaultCanonical ?? getCleanUrl(window.location.href));
    }
  }, [defaultCanonical]);

  // this function is used to generate hreflang URLs based on current page
  const getHreflangUrls = () => {
    if (!canonical) return { enUS: "", xDefault: "", en: "" };
    
    try {
      const url = new URL(canonical);
      const path = url.pathname;
      
      // For home page
      if (path === "/" || path === "") {
        return {
          enUS: "https://www.elchemy.com/",
          xDefault: "https://www.elchemy.com/",
          en: "https://www.elchemy.com/intl"
        };
      }
      
      // For intl pages
      if (path.includes("/intl")) {
        const basePath = path.replace("/intl", "");
        return {
          enUS: `https://www.elchemy.com${basePath}`,
          xDefault: `https://www.elchemy.com${basePath}`,
          en: `https://www.elchemy.com${path}`
        };
      }
      
      // For regular pages
      return {
        enUS: `https://www.elchemy.com${path}`,
        xDefault: `https://www.elchemy.com${path}`,
        en: `https://www.elchemy.com${path}/intl`
      };
    } catch (error) {
      return { enUS: "", xDefault: "", en: "" };
    }
  };

  const hreflangUrls = getHreflangUrls();

  return (
    <Head>
      <title>{title?.length ? title : DEFAULT_META_TITLE}</title>
      {addKey ? <meta name={addKey} content="Home Page" key="desc" /> : <></>}

      <meta
        name="title"
        content={metaTitle ?? title ?? DEFAULT_META_TITLE}
        key="title"
      />
      <meta
        name="description"
        content={description ?? DEFAULT_META_DESCRIPTION}
        key="description"
      />
      <meta
        property="og:title"
        content={metaTitle ?? title ?? DEFAULT_META_TITLE}
      />
      {NoIndexMetaKey ? <NoIndexMeta /> : <></>}
      <meta
        property="og:description"
        content={description ?? DEFAULT_META_DESCRIPTION}
      />
      <meta property="og:image" content={image ?? DEFAULT_META_IMAGE} />
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta
        name="twitter:title"
        content={metaTitle ?? title ?? DEFAULT_META_TITLE}
      ></meta>
      <meta
        name="twitter:description"
        content={description ?? DEFAULT_META_DESCRIPTION}
      ></meta>
      <meta
        name="twitter:image"
        content={image ?? DEFAULT_META_IMAGE}
      ></meta>
      <link rel="canonical" href={canonical ?? ""} />
      {/* {includeAlternateLink && <link rel="alternate" href={canonical} />} */}
      {includeAlternateLink && (
        <>
          <link rel="alternate" hreflang="en-US" href={hreflangUrls.enUS} />
          <link rel="alternate" hreflang="x-default" href={hreflangUrls.xDefault} />
          <link rel="alternate" hreflang="en" href={hreflangUrls.en} />
        </>
      )}
    </Head>
  );
};

export default MetaTags;
